"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;
var _index = require("../Icon/icons/IconChevronDown/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _layoutTheme = require("../../styles/layout-theme.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Arrow = exports.Arrow = (0, _styledComponents["default"])(_index.IconChevronDown).attrs({
  size: 'small',
  'aria-hidden': 'true'
}).withConfig({
  displayName: "Arrow",
  componentId: "sc-104rm6n-0"
})(["margin-inline-start:", ";", ";"], (0, _layoutTheme.cssSpacing)('tighter-4', '4px'), function (props) {
  return props.$expanded && (0, _styledComponents.css)(["transform:rotate(0.5turn);"]);
});